import { useSignOut } from '@/router/useSignOut';
import { getDeviceBranch, getNameInitials, getUser } from '@/utils';

/**
 * Surfaces the signed-in seller + enrolled branch for the top bar, and the
 * lock / switch-seller action (see `useSignOut`).
 */
export const useSellerSession = () => {
    const lock = useSignOut();

    const user = getUser();
    const branch = getDeviceBranch();
    const sellerName = user?.name ?? '';
    const sellerInitials = getNameInitials(sellerName);
    const branchName = branch?.name ?? '';

    return { sellerName, sellerInitials, branchName, lock };
};
